import IContaEscrow from '../entities/IContaEscrow'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface IListaContaEscrow {
  execute(frotistaId: number): Promise<IContaEscrow>
}

export default class ListaContaEscrowImpl implements IListaContaEscrow {
  constructor(private readonly pagamentosRepository: IPagamentoRepository) {}
  async execute(frotistaId: number): Promise<IContaEscrow> {
    return this.pagamentosRepository.listaContaEscrow(frotistaId)
  }
}
